/* eslint-disable react/no-typos */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Field,
  formValueSelector,
  reduxForm,
  change,
  clearFields,
} from 'redux-form';
import PropTypes from 'prop-types';

import containerWidth from '../../../../shared/helpers/containerWidth';
import { required, validateEmail } from '../../../../shared/libs/reduxFormValidations';
import InputCheckbox from '../../FormElements/Checkbox/CheckBox';
import TextArea from '../../FormElements/TextArea/TextArea';

import InputText from '../../FormElements/Input/Input';

import './FourthScreen.scss';

// eslint-disable-next-line react/prefer-stateless-function
class FourthScreen extends Component {
  constructor() {
    super();
    this.handleIsPropertyOwnerClick = this.handleIsPropertyOwnerClick.bind(this);
  }

  componentDidMount() {
    const {
      isForAccessSameAsProperty,
      propertyOwnerName,
      propertyOwnerEmail,
      propertyOwnerPhone,
      dispatch,
      form,
    } = this.props;
    if (!propertyOwnerName) {
      dispatch(change(form, 'contactForAccessSameAsPropertyOwner', false));
    } else if (isForAccessSameAsProperty) {
      dispatch(change(form, 'contactForAccess.companyName', propertyOwnerName));
      dispatch(change(
        form,
        'contactForAccess.phoneNumbers[0].phone',
        propertyOwnerPhone,
      ));
      dispatch(change(form, 'contactForAccess.email', propertyOwnerEmail));
    }
  }

  handleIsPropertyOwnerClick(e) {
    const {
      propertyOwnerName,
      propertyOwnerEmail,
      propertyOwnerPhone,
      dispatch,
      form,
    } = this.props;
    const inputValue = e.target.value;
    if (inputValue === 'false' || !inputValue) {
      dispatch(change(form, 'contactForAccess.companyName', propertyOwnerName));
      dispatch(change(
        form,
        'contactForAccess.phoneNumbers[0].phone',
        propertyOwnerPhone,
      ));
      dispatch(change(form, 'contactForAccess.email', propertyOwnerEmail));
    } else {
      dispatch(clearFields(
        form,
        true,
        true,
        'contactForAccess.companyName',
        'contactForAccess.phoneNumbers[0].phone',
        'contactForAccess.email',
      ));
    }
  }

  render() {
    const {
      isForAccessSameAsProperty,
      propertyOwnerName,
      config,
      handleSubmit,
    } = this.props;
    return (
      <form
        onSubmit={handleSubmit}
        className="row order_form_fourth"
        id="wizard-form"
      >
        <div className={containerWidth}>
          <div className="row">
            <div className="col-auto">
              <h5>Property Access</h5>
            </div>
            <div className="col">
              {propertyOwnerName && (
              <Field
                name="contactForAccessSameAsPropertyOwner"
                component={InputCheckbox}
                label={`Is it ${propertyOwnerName}?`}
                inputID="rushCheckbox"
                bemClass="inline-narrow-checkbox"
                onChange={this.handleIsPropertyOwnerClick}
              />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <Field
                name="contactForAccess.companyName"
                type="text"
                component={InputText}
                label="Name"
                placeholder="Jon Doe"
                disabled={isForAccessSameAsProperty}
                skipTouchedValidation
                required={config.companyName?.r}
                validate={[].concat(config.companyName?.r ? [required] : [])}
                hidden={config.companyName?.h}
              />
            </div>
            <div className="col-sm-6">
              <Field
                name="contactForAccess.phoneNumbers[0].phone"
                type="text"
                component={InputText}
                label="Phone"
                disabled={isForAccessSameAsProperty}
                placeholder="555-555-5555"
                required={config.phone?.r}
                validate={[].concat(config.phone?.r ? [required] : [])}
                hidden={config.phone?.h}
              />
            </div>
          </div>
          <Field
            name="contactForAccess.email"
            type="text"
            placeholder="example@example.com"
            component={InputText}
            disabled={isForAccessSameAsProperty}
            label="E-mail"
            required={config.email?.r}
            validate={[].concat(config.email?.r ? [required] : [])}
            hidden={config.email?.h}
            warn={[validateEmail]}
          />
          <Field
            name="contactForAccess.relationship"
            type="text"
            component={InputText}
            label="Relationship"
            placeholder="Realtor, tenant, etc"
            required={config.relationship?.r}
            validate={[].concat(config.relationship?.r ? [required] : [])}
            hidden={config.relationship?.h}
          />
          <Field
            name="contactForAccess.notes"
            placeholder="Anything we need to know?"
            component={TextArea}
            label="Access Instructions"
            rows={3}
            required={config.instructions?.r}
            validate={[].concat(config.instructions?.r ? [required] : [])}
            hidden={config.instructions?.h}
          />
        </div>
      </form>
    );
  }
}

FourthScreen.propTypes = {
  isForAccessSameAsProperty: PropTypes.bool,
  propertyOwnerName: PropTypes.string,
  propertyOwnerEmail: PropTypes.string,
  propertyOwnerPhone: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  form: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  config: PropTypes.objectOf(PropTypes.shape({
    r: PropTypes.bool,
    h: PropTypes.bool,
  })).isRequired,
};
FourthScreen.defaultProps = {
  isForAccessSameAsProperty: false,
  propertyOwnerName: null,
  propertyOwnerEmail: null,
  propertyOwnerPhone: null,
};

const selector = formValueSelector('WizardOrderForm');

const ReachFourthScreen = connect((state) => {
  const isForAccessSameAsProperty = selector(
    state,
    'contactForAccessSameAsPropertyOwner',
  );
  const propertyOwnerName = selector(state, 'propertyOwner.companyName');
  const propertyOwnerEmail = selector(state, 'propertyOwner.email');
  const propertyOwnerPhone = selector(state, 'propertyOwner.phone');

  return {
    isForAccessSameAsProperty,
    propertyOwnerName,
    propertyOwnerEmail,
    propertyOwnerPhone,
  };
})(FourthScreen);

export default reduxForm({
  form: 'WizardOrderForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: (values) => {
    const errors = {};
    const { contactForAccess } = values;
    const isFormClean = (Array.isArray(contactForAccess?.phoneNumbers)
        && contactForAccess.phoneNumbers[0].phone)
      || contactForAccess?.email
      || contactForAccess?.relationship
      || contactForAccess?.notes;
    if (isFormClean && !contactForAccess.companyName) {
      errors.contactForAccess = {
        companyName: 'Contact for access name is required',
      };
    }
    return errors;
  },
  persistentSubmitErrors: true,
})(ReachFourthScreen);
